import { useListingContext } from '@/context/listing';
import PropTypes from 'prop-types';
import React from 'react';
import { useTranslation } from 'react-i18next';
import normalizePlpPlusFacets from './utils';

const Facets = ({ facets }) => {
  const { t } = useTranslation();
  const {
    noFacets,
    hasOtherValues,
    otherValues,
    hasPriceValues,
    priceValues,
  } = normalizePlpPlusFacets(facets);
  const [, { pushQuery }] = useListingContext();

  if (noFacets) return null;

  return (
    <>
      {hasOtherValues && (
        <div className='--facets'>
          {otherValues.map(value => (
            <button
              key={value.name}
              type='button'
              className={`--facet-value ${value.selected ? ' --selected' : ''}`}
              onClick={() => pushQuery(value.query)}
            >
              {value.style && <i className='--color' style={value.style} />}
              {value.name}
            </button>
          ))}
        </div>
      )}
      {hasPriceValues && (
        <div className='--facets'>
          <h3 className='--price-label'>
            {t('listing:listing.plus.price.filter.label')}
          </h3>
          {priceValues.map(value => (
            <button
              key={value.code}
              type='button'
              className={`--facet-value ${value.selected && ' --selected'}`}
              onClick={() => pushQuery(value.query)}
            >
              {value.style && <i className='--color' style={value.style} />}
              {value.name}
            </button>
          ))}
        </div>
      )}
    </>
  );
};

Facets.propTypes = {
  facets: PropTypes.arrayOf(PropTypes.shape()),
};

Facets.defaultProps = {
  facets: [],
};

export default Facets;
